
import {reduxForm as RF} from "redux-form/immutable";

export const reduxForm = (options) => RF({
  touchOnBlur: false,
  ...options,
})
